
const ensureColonAtEnd = (label: string) => {
    if (label.endsWith(":")) {
        return label;
    } else {
        return label + ":";
    }
}

const LabelUtil = {
    ensureColonAtEnd,
};

export default LabelUtil;